var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Login',{directives:[{name:"ant-ref",rawName:"v-ant-ref",value:(
      function (form) {
        this$1.loginForm = form;
      }
    ),expression:"\n      form => {\n        this.loginForm = form;\n      }\n    "}],attrs:{"defaultActiveKey":_vm.type,"onTabChange":_vm.onTabChange,"onSubmit":_vm.handleSubmit}},[_c('Tab',{key:"account",attrs:{"tab":"账户密码登录"}},[(_vm.status === 'error' && _vm.type === 'account' && !_vm.submitting)?_c('VNodes',{attrs:{"vnodes":_vm.renderMessage('account')}}):_vm._e(),_c('UserName',{attrs:{"name":"username","placeholder":"用户名：","rules":[
          {
            required: true,
            message: '请输入用户名!'
          }
        ]}}),_c('Password',{attrs:{"name":"pwd","placeholder":"密码：","rules":[{ required: true, message: '请输入密码！' }],"onPressEnter":function (e) {
            e.preventDefault();
            this$1.form.validateFields(this$1.handleSubmit);
          }}})],1),_c('div',[_c('a-checkbox',{attrs:{"checked":_vm.autoLogin},on:{"change":_vm.changeAutoLogin}},[_vm._v("自动登录")]),_c('a',{staticStyle:{"float":"right"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.forgetPwd}},[_vm._v("忘记密码")])],1),_c('Submit',{attrs:{"loading":_vm.submitting}},[_vm._v("登录")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }